import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

export class AppConfig {
  rootConfig = '';
  commonApi = '';
  translationsFolder = '';
  configFolder = '';
  alternateDisplayForMarketsList = [];
}
export let APP_CONFIG: AppConfig;

@Injectable({ providedIn: 'root' })
export class ConfigService {

  constructor(private http: HttpClient) {
  }

  load(): Promise<any>{
    const promise = this.http.get('/assets/config/app-settings.json', {
      headers: new HttpHeaders({
        'Cache-Control':  'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        Pragma: 'no-cache',
        Expires: '0'
      })
    })
      .toPromise()
      .then( (data: any) => {
        APP_CONFIG = data;
        return data;
      });

    return promise;
  }

  getTranslate(lang: string): Observable<any> {
    return this.http.get(APP_CONFIG.rootConfig + APP_CONFIG.translationsFolder + lang + '.json',{
      headers: new HttpHeaders({
        'Cache-Control':  'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json'
      })
    });
  }

  getHeader(apiKey: string): any {
    return  {
      headers: new HttpHeaders({
        ApiKey: apiKey,
        'Content-Type': 'application/json',
      })
    };
  }
}
